import React, { useState } from "react";
import { RCCAlert, RCCButton, RCCGrid, RCCProgress, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import CardBadgesContent from "src/components/DashboardComponents/DefaultDashboardComponents/CardBadgesContent";
import CardContentSquares from "src/components/DashboardComponents/DefaultDashboardComponents/CardContentSquares";
import CardSquares from "src/components/DashboardComponents/DefaultDashboardComponents/CardSquares";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";
import { IDashboardProject } from "../interface";

const DashboardCardsProjectsPercentageOfProgram: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();
	const [dataProject, setDataProject] = useState<IDashboardProject>({
		count: 0.0001,
		delayed: 0,
		expectedPercentage: 0,
		finished: 0,
		inProgress: 0,
		nextToExpire: 0,
		notStarted: 0,
		percentage: 0,
		started: 0
	} as IDashboardProject);

	const { loading } = card?.daa002Idorigem ?  useEffectFetchData<IDashboardProject> (
		"DashboardProjects/ListProjectsOfProgramForPieChart", 
		{ id: card?.daa002Idorigem },
		({ data }) => {
			setDataProject(data);
		}
	): { loading: true };

	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Andamento Projetos por Programa")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<Link to="/projects/panel">
					<RCCTooltip
						text={translate("Painel de Projetos")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="projects"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>

			<DefaultBody>
				{!card?.daa002Idorigem ? (
					<RCCAlert 
						title={translate("Atenção")}
						description={translate("É necessário selecionar um programa")}
					/>
				):(
					<>
						<RCCGrid container item justifyContent="space-between" alignItems="center">
							<Title color="purple" marginTop={-4}>{dataProject.programTitle}</Title>
							<CardBadgesContent>
								<span className="default-color-font">  {translate("Total")}  {dataProject.count}</span>
								<span className="purple"> {translate("Não iniciados")} {dataProject.notStarted}</span>
							</CardBadgesContent>  
						</RCCGrid>
						<CardContentSquares>
							<CardSquares>
								<RCCProgress 
									layout="circle"
									value={dataProject.percentage}
									color="var(--purple)"
									width="70px"
								/>
								<span className="text"> {translate("Conclusão")} </span>
							</CardSquares>
							<CardSquares>
								<RCCProgress 
									layout="circle"
									value={dataProject.expectedPercentage}
									color="var(--purple)"
									width="70px"
								/>
								<span className="text"> {translate("Previsto")} </span>
							</CardSquares>
						</CardContentSquares>
					</>
				)}
			</DefaultBody>
		</DefaultContainer>
	);};

export default DashboardCardsProjectsPercentageOfProgram;
